import { useContext } from 'react';
import { CustomerContext } from '../context/customer-context';

export const useCustomer = () => {
  const customer = useContext(CustomerContext);

  return customer;
};
